module.exports = {
      id: "next-story-usage",
      viewBox: "0 0 40 40",
      url: "/" + "sprite-79b777a110ad18271a4fc79289e4208e.svg#next-story",
      toString: function () {
        return this.url;
      }
    }